export const APP_THEMES_LIGHT = 'light'
export const APP_THEMES_DARK = 'dark'
// tabs
export const TAB_CONFIG = 'config_tab'
export const TAB_ALTER_SYSTEM = 'alter_tab'
